import DatasourceDropDown from './DatasourceDropDown'

export default {
  install(Vue) {
    Vue.component('datasource-dropdown', DatasourceDropDown)
  },
}
